<template>
	<div v-parallax-fit="parallax" ref="slide_finish" class="slide-finish">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/11_finalphoto.png">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 27900,
						end: 28600,
						fromStyle: { transform: 'translateX(-50%) translateY(0%) rotate(7deg) scale(1)', opacity: 0 },
           				toStyle: { transform: 'translateX(-50%) translateY(200%) rotate(0deg) scale(1.4)', opacity: 1 },
						easing: 'linear'
					}
				]
			}
		},
	}
</script>

<style lang="scss" scoped>
	.slide-finish {
		max-width: 350px;
	    position: absolute;
	    left: 50%;
	    top: -100%;
	    transition: all 0.1s linear;
	}

	@media screen and (max-width: 1680px) {
		.slide-finish {top: -115%;}
	}

	@media screen and (max-width: 1440px) {
		.slide-finish {top: -140%;}
	}

	@media screen and (max-width: 1280px) {
		.slide-finish {
			max-width: 200px;
			top: -109%;
		}
	}

	@media screen and (max-width: 650px) {
		.slide-finish {max-width: 100px;}
	}
</style>
